import ServicosCnaeDetService from "@/services/ServicosCnaeDetService";

export const servicosCnaeDet = {
  namespaced: true,
  state: {
    servicosCnaeDet: {},
  },
  actions: {
    getServicosCnaeDet({ commit }, payload) {
      return ServicosCnaeDetService.GetServicosCnaeDet(payload).then(
        (servicosCnaeDet) => {
          return Promise.resolve(servicosCnaeDet);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postServicosCnaeDet({ commit }, payload) {
      return ServicosCnaeDetService.PostServicosCnaeDet(payload).then(
        (servicosCnaeDet) => {
          return Promise.resolve(servicosCnaeDet);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putServicosCnaeDet({ commit }, payload) {
      return ServicosCnaeDetService.PutServicosCnaeDet(payload).then(
        (servicosCnaeDet) => {
          return Promise.resolve(servicosCnaeDet);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteServicosCnaeDet({ commit }, payload) {
      return ServicosCnaeDetService.DeleteServicosCnaeDet(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getServicosCnaeDetOData({ commit }, payload) {
      return ServicosCnaeDetService.GetServicosCnaeDetOData(payload).then(
        (servicosCnaeDet) => {
          return Promise.resolve(servicosCnaeDet);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default servicosCnaeDet;
